import React from "react";

import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import moment from "moment";

import type { JSX, ReactNode } from "react";

interface DateSelectorProps {
  currentDay: string | Date;
  onClickPrevious: () => void;
  onClickNext: () => void;
  onClickCurrent: () => void;
  label: string | ReactNode;
  children?: ReactNode;
}

function DateSelector({
  currentDay,
  onClickPrevious,
  onClickNext,
  onClickCurrent,
  children,
  label,
}: DateSelectorProps): JSX.Element {
  const containerClasses = classNames(
    "flex justify-center border rounded-[0.46875rem] border-input bg-card drop-shadow-md w-full",
  );

  const labelClasses = classNames(
    "flex flex-col items-center capitalize text-2xl leading-6 p-[0.78125rem] min-w-[150px] text-foreground",
    !moment(currentDay).isSame(moment(), "day") &&
      "hover:bg-muted cursor-pointer",
  );

  const arrowClasses = classNames(
    "flex flex-1 items-center justify-center w-[2.1875rem] text-muted-foreground first:border-r first:rounded-l-xl last:border-l last:rounded-r-xl border-input hover:bg-muted cursor-pointer",
  );
  return (
    <div className="flex flex-1 justify-center">
      <div className="flex w-[250px] flex-col items-stretch justify-center gap-[0.46875rem]">
        <div className={containerClasses}>
          <button
            className={arrowClasses}
            onClick={onClickPrevious}
            type="button"
          >
            <Icon path={mdiArrowLeft} size={0.9375} />
          </button>
          <button onClick={onClickCurrent} type="button">
            <div className={labelClasses}>{label}</div>
          </button>
          <button className={arrowClasses} onClick={onClickNext} type="button">
            <Icon path={mdiArrowRight} size={0.9375} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export default DateSelector;
